(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function ($) {
  $(document).ready(function () {
    var url = $('input[name="ajaxurl"]').val();
    var nonce = $('input[name="news_pagination_nonce"]').val();
    var nextPage = {};
    var marker = '';
    var classes = '';
    var title = '';
    var index = 0;
    $('#news-navigation ul.pagination a.page-link').on('click', function (element) {
      classes = element.currentTarget.classList;
      var index = parseInt(classes.length - 2);
      marker = classes[index];
      title = $('h1.' + marker)[0].innerHTML;
      nextPage = parseInt(element.target.innerHTML);
      element.preventDefault();

      if (isNaN(nextPage)) {
        var currentPage = parseInt($('span.page-link.current')[0].innerHTML);

        if (element.target.classList.contains('next')) {
          //Suivant
          nextPage = currentPage + 1;
        } else if (element.target.classList.contains('prev')) {
          nextPage = currentPage - 1;
        }
      }

      Navigate(url, 'news', nonce, nextPage, marker, title);
    });
    $('#videos-navigation ul.pagination a.page-link').on('click', function (element) {
      classes = element.currentTarget.classList;
      var index = parseInt(classes.length - 2);
      marker = classes[index];
      title = $('h1.' + marker)[0].innerHTML;
      nextPage = parseInt(element.target.innerHTML);
      element.preventDefault();

      if (isNaN(nextPage)) {
        var currentPage = parseInt($('span.page-link.current')[0].innerHTML);

        if (element.target.classList.contains('next')) {
          //Suivant
          nextPage = currentPage + 1;
        } else if (element.target.classList.contains('prev')) {
          nextPage = currentPage - 1;
        }
      }

      Navigate(url, 'videos', nonce, nextPage, marker, title);
    });
  });

  function Navigate(url, postType, nonce, nextPage, marker, title) {
    if (parseInt(nextPage)) {
      $.ajax({
        url: url,
        type: 'post',
        data: {
          args: {
            post_type: postType,
            post_status: 'publish',
            paged: nextPage,
            "class": marker,
            title: title,
            icon: ''
          },
          action: 'news_next_page',
          nonce: nonce
        },
        error: function error(_error) {
          console.error(_error);
        },
        success: function success(response) {
          $('section.' + marker).empty();
          $('.news-navigation').remove();
          $('section.' + marker).append(response);
          $('ul.pagination a.page-link').on('click', function (element) {
            nextPage = parseInt(element.target.innerHTML);
            element.preventDefault();

            if (isNaN(nextPage)) {
              var currentPage = parseInt($('span.page-link.current')[0].innerHTML);

              if (element.target.classList.contains('next')) {
                //Suivant
                nextPage = currentPage + 1;
              } else if (element.target.classList.contains('prev')) {
                nextPage = currentPage - 1;
              }
            }

            Navigate(url, nonce, nextPage, marker, title);
          });
        }
      });
    }
  }

  $('#document-navigation ul.pagination a.page-link').on('click', function (element) {
    element.preventDefault();
    var reqYear = parseInt(element.currentTarget.innerHTML); //let currentYear = $('#document-navigation ul.pagination li.active a.page-link').innerHTML

    var currentYear = parseInt(document.querySelector('#document-navigation ul li.active a.page-link').childNodes[0].data);
    if (currentYear === reqYear) return;
    PaginateYearsNavigate(reqYear);
    var navLi = document.querySelectorAll('#document-navigation ul li');

    var _iterator = _createForOfIteratorHelper(navLi),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var li = _step.value;
        li.classList.remove('active');
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    element.currentTarget.parentElement.classList.add('active');
  });

  function PaginateYearsNavigate(reqYear) {
    $.ajax({
      url: ajaxPagination.ajax_url,
      type: 'post',
      data: {
        args: {
          post_type: 'document',
          post_status: 'publish',
          title: "Documents officiels de l'année " + reqYear,
          year: reqYear
        },
        action: 'change_year',
        nonce: ajaxPagination.page_per_year_nonce
      },
      dataType: 'JSON',
      success: function success(response) {
        var targetHeader = document.querySelector('#official-documents .card .card-header');
        var targetsBody = document.querySelector('#official-documents .card .card-body');
        targetHeader.innerHTML = response.title;
        targetsBody.innerHTML = response.body;
      }
    });
  }
})(jQuery);

},{}]},{},[1]);
